export default {
  have_account: 'Onko sinulla tili?',
  sign_in: 'Kirjaudu sisään',
  sign_in_description: 'käyttääksesi pisteitäsi ja tallennettuja tietojasi',
  join_free: 'Liity ilmaiseksi',
  join_description: '— ansaitse etuja jokaisesta tilauksesta',
  join_description_with_discount: `— ansaitse etuja, kuten jopa <highlight>{{max_discount}} alennusta</highlight> jokaisesta tilauksesta`,
  join_description_with_product_and_discount: `— ansaitse etuja, kuten ilmainen {{product_name}} ja jopa <highlight>{{max_discount}} alennusta</highlight> jokaisesta tilauksesta`,
  demo_mode: 'Demotila',
};
